module.exports = __webpack_public_path__ + "img/category_trackarumi.5dcef20b.jpg";